import axios from 'axios'

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://qmv-report-api.huestimates.net'
    : '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': 'x7lmq9arcz'
  }
})

// Generate and add Request Correlation ID to header for tracking
api.interceptors.request.use((config) => {
  try {
    if (typeof crypto.randomUUID === 'function') {
      config.headers['X-Request-Correlation-Id'] = crypto.randomUUID();
    } else {
      config.headers['X-Request-Correlation-Id'] = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  } catch (e) {
    config.headers['X-Request-Correlation-Id'] = 'error-generating-id';
  }
  return config;
})

export const reportApi = {
  // Client-in məlumatlarını al
  getClientByToken(token, isVisit = false) {
    return api.get(`/Report/GetClientInfo?publicToken=${token}&isVisit=${isVisit}`)
  },

  // Client-in sessiyalarının hesabatını al
  getClientSessions(token) {
    return api.get(`/Report/GetClientSessions?publicToken=${token}`)
  },

  // Sessiyanın məkan statistikasını al
  getSessionLocations(sessionId) {
    return api.get(`/Report/GetSessionLocations?sessionId=${sessionId}`)
  },

  // Sessiyanın məhsul növü statistikasını al
  getSessionProducts(sessionId) {
    return api.get(`/Report/GetSessionProducts?sessionId=${sessionId}`)
  }
}

export default api
